<template>
  <v-container v-if="machine">
    <v-row>
      <v-col>
        <v-container class="bordered bg-white mb-4">
          <NormalInput
            :id="nodeId"
            class="mb-4"
            field="manufacturer_machine" />

          <NormalInput
            :id="nodeId"
            class="mb-4"
            field="category_machine" />

          <NormalInput
            :id="nodeId"
            class="mb-4"
            field="type_machine" />

          <NormalInput
            :id="nodeId"
            class="mb-4"
            field="id_number_machine" />

          <component
            :is="machine.level > 1 ? CalcOutput : CalcInputNumber"
            :id="nodeId"
            class="mb-4"
            field="machine_hourly_rate_machine"
            :rules="[required, positive]" />
        </v-container>

        <v-container class="bordered bg-white">
          <NotesEditor
            :id="nodeId"
            field="comment"
            :placeholder="$t('entities.variant.fields.base_data_notes')" />
        </v-container>
      </v-col>
      <v-col>
        <CarouselWithUpload
          field="basic-data"
          :node-id="nodeId" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from "vue";

import CalcOutput from "@/components/Elements/CalcOutput.vue";
import CarouselWithUpload from "@/components/Elements/CarouselWithUpload.vue";
import { useSpaceStore } from "../../../../stores/spaceStore";
import NotesEditor from "@/components/Elements/NotesEditor.vue";
import NormalInput from "@/components/Elements/NormalInput.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";

const spaceStore = useSpaceStore();

const machine = ref(null);

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

onMounted(() => {
  machine.value = spaceStore.getElement(props.nodeId);
});
</script>
